import type { ReactNode, SVGProps } from "react";

export function StatementDownloadIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="-1.875 -1.875 17 17"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.27206 11.2917H2.03676C1.66234 11.2917 1.30325 11.1512 1.0385 10.9011C0.773739 10.6511 0.625 10.312 0.625 9.95833V1.95833C0.625 1.60471 0.773739 1.26557 1.0385 1.01552C1.30325 0.765476 1.66234 0.625 2.03676 0.625H10.5074V3.95833"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.97794 8.625H2.03676C1.66234 8.625 1.30325 8.76548 1.0385 9.01552C0.773739 9.26557 0.625 9.60471 0.625 9.95833"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M8.38965 10.625L10.5073 12.625L12.6249 10.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M10.5073 12.625V6.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
